'use client';

import {X, Undo} from 'lucide-react';
import {Card, CardContent} from '../card/card';
import {Button} from '../button/button';
import {layoutByState} from './layoutProps';

type ToastData = {
  title: string;
  content: string;
  state: 'error' | 'success';
  onUndo?: () => void;
  onClose?: () => void;
  withUndo?: boolean;
};

export const Toast = ({data}: {data: ToastData}) => {
  const {backgroundColor, color} = layoutByState[data.state];
  return (
    <Card className="w-full text-white" style={{background: backgroundColor}}>
      <CardContent className="space-y-2 px-6 py-4">
        <div className="flex items-center justify-between" style={{color}}>
          <h4 className="text-sm font-semibold">{data.title}</h4>
          <X
            className="ml-2 h-4 min-h-4 w-4 min-w-4 cursor-pointer"
            onClick={data.onClose}
          />
        </div>

        {data.content && (
          <p className="text-sm" style={{color}}>
            {data.content}
          </p>
        )}

        {data.withUndo && (
          <div className="flex justify-end">
            <Button
              variant="secondary"
              size="sm"
              onClick={data.onUndo}
              className="gap-1 rounded-full border border-white/30 bg-white px-4 text-black"
              aria-label="Angre"
            >
              Undo
              <Undo className="h-4 w-4 text-black" />
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default Toast;
